/**
 * Displays a blue and red banner at the top with the BUIHA logo and a title
 */

import React from "react";

const CoreBanner = ({ title }) => {
  return (
    // BUIHA Colours Gradient
    <div className="border-b-2 border-light-3 dark:border-dark-3 w-full homegradient bg-gradient-to-r from-blue-600 to-red-600 flex flex-row w-full justify-center items-center py-2">
        <img src={`/buihamini.png`} alt="BUIHA" className="h-20 w-20" />
        <div className="flex flex-col justify-left items-left xxs:mx-4">
          <h1 className="xxs:text-4xl text-2xl xs:text-5xl pb-1 text-white font-semibold leading-tight text-center">
            {title}
          </h1>
        </div>
    </div>
  );
};

export default CoreBanner;
